<template>
    <dashlet-card :page-tooltip="t_page_tooltip_publish"
                  :title="t_title"
                  page-href="/content/publish">
        <template #prependButton>

            <preview-size-change-button :line-size="lineSize"
                                        @input="lineSize = $event" />

            <square-button :disabled="loading"
                           :loading="loading"
                           :tooltip-text="t_refresh_tooltip"
                           flat
                           icon="far fa-arrows-rotate"
                           @click="refreshPublishList" />
        </template>

        <div v-if="error"
             class="ibox-content ">
            <div class="load-publish-notifications">
                <div class="alert alert-danger"
                     style="margin-bottom: 0;">
                    {{ t_error_not_loaded }}
                </div>
            </div>
        </div>


        <publish-overview-table ref="publishOverviewTable"
                                :num-entries="showCount"
                                :screens-data="screensData"
                                :line-size="lineSize"
                                @error="error = $event"
                                @loading="loading = $event" />

<!--                        <pre>showCount: {{showCount}}</pre>
                        <pre>screensData: {{screensData}}</pre>-->

    </dashlet-card>
</template>

<script>
import DashletCard from '../dashlet-card.vue'
import SquareButton from '../../../content/common/squareButton.vue'
import PublishOverviewTable from './publish-overview-table.vue'
import PreviewSizeChangeButton from '../../../content/publish/previewSizeChangeButton.vue'

export default {
    props: {
        showCount: Number,

        /** @type {ScreensData} */
        screensData: Object
    },
    components: {
        PreviewSizeChangeButton,
        PublishOverviewTable,
        SquareButton,
        DashletCard
    },
    data() {
        return {
            error: false,
            loading: true,

            /** @type {'small' | 'medium' | 'large'}*/
            lineSize: 'small',

            t_title: Lang.langGet('Publish'),
            t_page_tooltip_publish: Lang.langGet('Publish'),
            t_refresh_tooltip: Lang.langGet('Reload'),

            t_error_not_loaded: Lang.langGet('Failed to load layer data!')
        }
    },
    computed: {
        localStorageKeyLineSize() {
            return `publish-dashlet-line-size.${Laravel.activeUser}.${Laravel.activeProject}`
        },
    },
    methods: {
        refreshPublishList() {
            this.$refs.publishOverviewTable.loadData()
        }
    },
    watch: {
        lineSize(val) {
            localStorage.setItem(this.localStorageKeyLineSize, val);
        }
    },
    created() {
        this.lineSize = localStorage.getItem(this.localStorageKeyLineSize) ?? 'small';
    }
}
</script>
